import { Text, Title } from "@mantine/core";

export const Text12Medium = Text.withProps({ fz: "12px", fw: 500 });
export const Text16Medium = Text.withProps({ fz: "16px", fw: 500 });

export const Title3 = Title.withProps({ order: 3 });
export const Title5 = Title.withProps({ order: 5 });
